var TYPES = {
  NetworkService: Symbol["for"]('NetworkService'),
  Translate: Symbol["for"]('Translate'),
  UserSource: Symbol["for"]('UserSource'),
  User: Symbol["for"]('User')
};
export default TYPES;